import { Injectable } from "@angular/core";
import { AngularFireDatabase } from "angularfire2/database";
import { Observable } from "rxjs/Observable";
import { IOpinometer, IQuestion } from "../shared/models/opinometer.model";

@Injectable()
export class OpinometerData {

  constructor(
    private afDb: AngularFireDatabase,
  ) { }

  public getOpinometersByClient(client: string): Observable<IOpinometer[]> {
    return this.afDb.list<IOpinometer>(`Clients/${client}/Surveys`).
      valueChanges();
  }

  public getOpinometerById(client: string, id: string): Observable<IOpinometer> {
    return this.afDb.object<IOpinometer>(`Clients/${client}/Surveys/${id}`).
      valueChanges();
  }

  public createOpinometer(client: string, opinometer: IOpinometer) {
    if (opinometer.id === "") { opinometer.id = this.afDb.createPushId(); }

    return new Promise((resolve, reject) => {
      return this.afDb.database.ref(`Clients/${client}/Surveys/${opinometer.id}`)
        // TODO: Fix resolve .set to .update
        .set(opinometer)
        .then(() =>  {
          resolve(opinometer);
         })
        .catch((error) => {
         reject(error);
        });
    });
  }

  public updateQuestionByOpinometerId(client: string, id: string, questions: IQuestion[]): Observable<any> {
    return Observable.fromPromise(
      this.afDb.object<IOpinometer>(`Clients/${client}/Surveys/${id}`)
        .update({ Questions: questions }));
  }
}
 // end file



// WEBPACK FOOTER //
// ./src/providers/opinometer.ts